import { render } from "./BannerCont.vue?vue&type=template&id=517cfee2"
const script = {}

import "./BannerCont.vue?vue&type=style&index=0&id=517cfee2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__